export default "__VITE_PUBLIC_ASSET__0a13a583__"